import React from 'react';
import PropTypes from 'prop-types';
import { Typography, useMediaQuery } from '@material-ui/core';
import { makeStyles, useTheme } from '@material-ui/styles';

export default function FHETitle(props) {
    const { Icon, title, subTitle, MuiIcon, suffixTitle } = props;
    const classes = useStyles(props);
    const theme = useTheme();
    const matches = useMediaQuery(theme.breakpoints.down('xs'));

    return (
        <div className={classes.title}>
            <Typography variant="h4" className={classes.h4}>
                {Object.getOwnPropertyNames(Icon).length > 0 ? (
                    <span>
                        <Icon color={theme.palette.primary.main} size={matches ? 25 : 35} />
                    </span>
                ) : (
                    MuiIcon && <MuiIcon className={classes.muiIcon} />
                )}
                <span className={classes.textTitle}>
                    <span>{title} </span>
                    {suffixTitle && (
                        <Typography display="inline" className={classes.textSuffixTitle} variant="subtitle1">
                            {suffixTitle}
                        </Typography>
                    )}
                    {subTitle && (
                        <Typography className={classes.textSubTitle} variant="subtitle1">
                            {subTitle}
                        </Typography>
                    )}
                </span>
            </Typography>
        </div>
    );
}
FHETitle.defaultProps = {
    Icon: {},
    MuiIcon: null,
    subTitle: null,
    suffixTitle: null
};

FHETitle.propTypes = {
    title: PropTypes.string.isRequired,
    subTitle: PropTypes.oneOfType([PropTypes.string, PropTypes.array]),
    suffixTitle: PropTypes.string,
    Icon: PropTypes.object,
    MuiIcon: PropTypes.func
};

const useStyles = makeStyles(theme => ({
    h4: {
        lineHeight: 1
    },
    title: {
        color: theme.palette.primary.main,
        marginBottom: 30,
        marginRight: 45,
        [theme.breakpoints.down('xs')]: {
            marginBottom: 20,
            marginLeft: 5
        }
    },
    textTitle: {
        marginLeft: 10,
        verticalAlign: 'middle',
        [theme.breakpoints.down('xs')]: {
            fontSize: '0.7em',
            marginLeft: 5
        }
    },
    textSubTitle: {
        marginLeft: 20,
        [theme.breakpoints.down('xs')]: {
            fontSize: '0.5em'
        }
    },
    textSuffixTitle: {
        marginLeft: 20,
        whiteSpace: 'nowrap',
        fontSize: '0.5em',
        [theme.breakpoints.down('md')]: {
            display: 'block',
            fontSize: '0.5em'
        },
        [theme.breakpoints.down('sm')]: {
            whiteSpace: 'normal'
        }
    },
    muiIcon: {
        fontSize: 40,
        [theme.breakpoints.down('xs')]: {
            fontSize: 30
        }
    }
}));



// WEBPACK FOOTER //
// ./data/components/FHETitle.js